/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const documentBoxStyle = {
  paper: {
    padding: "0.25rem 1rem 1rem",
  },
  headline: {
    textAlign: "center",
    color: "primary.main",
    marginBottom: "40px",
  },
  gridSpace: (theme: Theme) => ({
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3rem",
    },
  }),
  uploadButton: (theme: Theme) => ({
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
    },
  }),
  headlineContainer: {
    margin: "2rem 0 2rem 0",
    justifyContent: "center",
  },
};

export default documentBoxStyle;
